import { render } from "./Detection.vue?vue&type=template&id=da30d5d6&scoped=true"
import script from "./Detection.vue?vue&type=script&lang=js"
export * from "./Detection.vue?vue&type=script&lang=js"

import "./Detection.vue?vue&type=style&index=0&id=da30d5d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da30d5d6"]])

export default __exports__